

const state = {
    tabs: [{name: 'Ogeysiisyada',
            url:  '/ogeysis'}, 
            
            {name: 'Electronics',
              url:  "/electronics"},
            {name: 'Gawaari',
              url:   "/gawaari"},
            {name: 'Guryaha/Xafiis',
              url:  '/guryaha'}
            ]
};
const getters = {
    tabs:    state   =>  state.tabs
};

const actions = {


};

const mutations = {


};


export default {
    state, 
    getters, 
    actions,
    mutations
}